import { CloudDownloadOutlined, FormatPainterFilled } from "@ant-design/icons";
import { Tooltip, Typography, message, Checkbox } from "antd";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import Highcharts from "highcharts/highcharts.js";
import solidGauge from "highcharts/modules/solid-gauge.js";
import { encode } from "js-base64";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { postData } from "../../resources/utils";
import "./FarmerScoreCard.css";
import { apiurls } from "../../resources/APIurls";
import { appconfig } from "../../resources/config";

highchartsMore(Highcharts);
solidGauge(Highcharts);

const FarmerScoreCardv3 = ({
  basicDetails,
  cropHistory,
  profitLoss,
  riskProfile,
  weatherTrend,
  sampleScreenshot,
  featureType,
  googgleImages,
  setMapLoader,
  KhasraScreenShort,
  coordinatesData,
  basicDetailsScore,
  cropHistoryDetailsScore,
  profitLossDetailsScore,
  riskProfileDetailsScore
}) => {
  let apikey_s3 = apiurls.find((item) => item.apikey == "aws3");
  const aws_s3_url = `${appconfig.domain[appconfig.environment].aws3}${
    apikey_s3.paths.images
  }`;
  const [messageApi, contextHolder] = message.useMessage();
  const [score, setScore] = useState(0);
  const [basicDetailScore, setBasicDetailScore] = useState(0);
  const [landDetailScore, setLandDetailScore] = useState(0);
  const [farmlandDetailScore, setFarmlandDetailScore] = useState(0);
  const [yieldScore, setYieldScore] = useState(0);
  const [profitLossDetailScore, setProfitLossDetailScore] = useState(0);
  const [riskDetailScore, setRiskDetailScore] = useState(0);
  const [totalCreditScore, setTotalCreditScore] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [scoreBreakup, setScoreBreakup] = useState({
    basicDetails: {
      name: 0,
      address: 0,
      khasra: 0,
      numberOfFarmlands: 0,
      totalFarmlandArea: 0,
      validation: 0,
    },
    cropHistory: {
      cropGrowingFactor: 0,
      yieldFactor: 0,
    },
    profitLoss: {
      cropHealth: 0,
      soilHealth: 0,
      farmIncome: 0,
    },
    riskProfile: {
      weatherFloodRisk: 0,
      cropSuitability: 0,
      cropExpertise: 0,
      farmManagement: 0,
    },
  });
  const [creditChartOptions, setCreditChartOptions] = useState({
    chart: {
      type: "gauge",
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 180,
      width: 300,
    },

    title: {
      text: "Your Credit Score is",
    },
    credits: {
      enabled: false,
    },
    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ["50%", "75%"],
      size: "90%",
    },

    // the value axis
    yAxis: {
      min: 0,
      max: 100,
      tickPositions: [0, 30, 60, 80, 100],
      tickPixelInterval: 72,
      tickPosition: "inside",
      tickColor: "#FFFFFF",
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: {
        distance: 20,
        style: {
          fontSize: "14px",
        },
      },
      plotBands: [
        {
          from: 0,
          to: 30,
          color: "#DF5353",
          thickness: 20,
        },
        {
          from: 30,
          to: 60,
          color: "#DDDF0D",
          thickness: 20,
        },
        {
          from: 60,
          to: 80,
          color: "#55BF3B",
          thickness: 20,
        },
        {
          from: 80,
          to: 100,
          color: "#3b8529",
          thickness: 20,
        },
      ],
    },

    series: [
      {
        name: "Score",
        data: [score],
        tooltip: {
          valueSuffix: "",
        },
        dataLabels: {
          format: "{y}",
          borderWidth: 0,
          color: "#333333",
          style: {
            fontSize: "24px",
          },
        },
        dial: {
          radius: "50%",
          backgroundColor: "gray",
          baseWidth: 12,
          baseLength: "0%",
          rearLength: "0%",
        },
        pivot: {
          backgroundColor: "gray",
          radius: 6,
        },
      },
    ],
  });

  const [cashflowChartOptions, setCashflowChartOptions] = useState({
    chart: {
      type: "column",
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      width: 900,
    },

    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    pane: {
      startAngle: -90,
      endAngle: 89.9,
      background: null,
      center: ["50%", "75%"],
      size: "90%",
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      crosshair: true,
    },
    yAxis: {
      min: 0,
    },
    plotOptions: {
      column: {
        colorByPoint: true,
      },
    },
    colors: [
      "#B0E896",
      "#5C87E9",
      "#B0E896",
      "#5C87E9",
      "#B0E896",
      "#5C87E9",
      "#B0E896",
      "#5C87E9",
      "#B0E896",
      "#5C87E9",
      "#5C87E9",
      "#5C87E9",
    ],
    series: [
      {
        name: "Month",
        data: [0, 0, 102410, 0, 0, 10600, 29950, 0, 0, 118800, 13061, 34700],
      },
    ],
  });

  const [weatherTrendChartOptions, setWeatherTrendChartOptions] = useState({
    chart: {
      plotBackgroundColor: "#ffffff",
      backgroundColor: "#ffffff",
      plotBorderWidth: 0,
      plotShadow: false,
      width: 900,
    },
    credits: {
      enabled: false,
    },
    legend: {
      // enabled: false,
    },
    title: {
      text: "",
    },
    yAxis: [
      {
        lineWidth: 1,
        //gridLineColor: "transparent",
        title: {
          text: "Rainfall (mm)",
        },
      },
      {
        lineWidth: 1,
        //gridLineColor: "transparent",
        opposite: true,
        title: {
          text: "Temperature (°C)",
        },
      },
    ],
    xAxis: {
      // type: "datetime",
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      crosshair: true,
    },
    plotOptions: {
      area: {
        marker: {
          enabled: false,
          symbol: "circle",
          radius: 2,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
      },
      series: {
        fillOpacity: 0.2,
      },
    },
    series: [
      {
        type: "column",
        name: "Rainfall",
        data: [6, 40, 10, 20, 5, 50, 30, 40, 35, 21, 38, 45],
        color: "#B0E896",
      },
      {
        type: "spline",
        name: "Temperature",
        data: [12, 15, 16, 18, 45, 32, 57, 23, 26, 16, 17, 12],
        color: "#5C87E9",
        yAxis: 1,
      },
    ],
  });

  const getMajorCropSown = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return "--";
  const validArr = arr.filter((o) => typeof o.value === "number" && o.value > 0);
  if (validArr.length === 0) return "--";
  const majorCropArea = Math.max(...validArr.map((o) => o.value));
  const majorCrop = validArr.find((item) => item.value === majorCropArea);
  return majorCrop?.name || "--";
};

const getMajorYield = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return "--";
  const validCrops = arr.map(c => ({
    ...c,
    cropArea: Number(c.cropArea) || 0,
  }));
  const majorCropArea = Math.max(...validCrops.map(c => c.cropArea));
  if (majorCropArea === 0) return "--";
  const majorCrop = validCrops.find(c => c.cropArea === majorCropArea);
  return majorCrop || "--";
};

const getTotalSowing = (cropHistory) => {
  if (!cropHistory || cropHistory.length === 0) return "--";
  const totalValue = cropHistory.reduce((sum, c) => sum + c.value, 0);
  const totalFieldArea =
    cropHistory[0]?.total_field_area ||
    Math.max(...cropHistory.map((c) => c.value));
  return totalValue > totalFieldArea ? totalFieldArea.toFixed(3) : totalValue.toFixed(3);
};

const getTotalSowingPercentage = (cropHistory) => {
  if (!cropHistory || cropHistory.length === 0) return "--";
  const totalValue = cropHistory.reduce((sum, c) => sum + c.value, 0);
  const totalFieldArea =
    cropHistory[0]?.total_field_area ||
    Math.max(...cropHistory.map((c) => c.value));

  const percentage = (totalValue / totalFieldArea) * 100;
  return percentage;
};

const handleYieldBgColor = (yieldObj) => {
  let majorYieldObj = getMajorYield(yieldObj);

  if (!majorYieldObj || majorYieldObj.cropArea === 0 || majorYieldObj.crop === "-") {
    return "#F97979"; 
  }
  const maxFarmYield = Number(majorYieldObj.maxFarmLevelCropYield);
  const minFarmYield = Number(majorYieldObj.minFarmLevelCropYield);
  const minDistrictYield = Number(majorYieldObj.minDistrictLevelCropYield);
  const maxDistrictYield = Number(majorYieldObj.maxDistrictLevelCropYield);

  const farmAvgYield = (maxFarmYield + minFarmYield) / 2;
  const districtAvgYield = (maxDistrictYield + minDistrictYield) / 2;
  const yieldXvalue = minDistrictYield - (0.2 * minDistrictYield);

  if (farmAvgYield <= yieldXvalue || farmAvgYield === 0 || isNaN(farmAvgYield)) {
    return "#F97979";   
  } else if (farmAvgYield >= districtAvgYield) {
    return "#B0E896";  
  } else {
    return "#F9FFC2";  
  }
}

const updateCashFlowChart = () => {
  const graphObj = JSON.parse(JSON.stringify(cashflowChartOptions));
  const objKeys = Object.keys(profitLoss.profit_loss_estimates[0]);
  const objKey_rabi = objKeys.find(k => k.includes("rabi"));
  const objKey_kharif = objKeys.find(k => k.includes("kharif"));
  const rabi = profitLoss.profit_loss_estimates[0][objKey_rabi];
  const kharif = profitLoss.profit_loss_estimates[0][objKey_kharif];
  const sumIncome = (arr) =>
    Array.isArray(arr)
      ? arr.reduce((s, c) => s + (c.estimated_value_of_produce || 0), 0)
      : 0;

  const sumExpense = (arr) =>
    Array.isArray(arr)
      ? arr.reduce((s, c) => s + (c.estimated_cost_of_production || 0), 0)
      : 0;

  const rabiIncome = sumIncome(rabi);
  const rabiExpense = sumExpense(rabi);

  const kharifIncome = sumIncome(kharif);
  const kharifExpense = sumExpense(kharif);

  const data = Array(12).fill(null);
  const colors = Array(12).fill(null);
  const types = Array(12).fill("");
  const seasons = Array(12).fill("");

  // ---------- Rabi ----------
  if (rabiIncome > 0) {
    data[2] = rabiIncome;
    colors[2] = "#B0E896";
    types[2] = "Income";
    seasons[2] = objKey_rabi;
  }

  if (rabiExpense > 0) {
    data[10] = rabiExpense;
    colors[10] = "#5C87E9";
    types[10] = "Expense";
    seasons[10] = objKey_rabi;
  }

  // ---------- Kharif ----------
  if (kharifExpense > 0) {
    data[5] = kharifExpense;
    colors[5] = "#5C87E9";
    types[5] = "Expense";
    seasons[5] = objKey_kharif;
  }

  if (kharifIncome > 0) {
    data[9] = kharifIncome;
    colors[9] = "#B0E896";
    types[9] = "Income";
    seasons[9] = objKey_kharif;
  }

  graphObj.series[0].data = data.map((val, i) => ({
    y: val,
    color: colors[i] || undefined,
    type: types[i] || null,
    season: seasons[i] || null,
  }));

  setCashflowChartOptions(graphObj);
};

  const updateWeatherTrendChart = () => {
    let graphObj = { ...weatherTrendChartOptions };
    graphObj.series[0].data = [];
    graphObj.series[0].data.push(weatherTrend.rainfall[0][1]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][2]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][3]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][4]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][5]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][6]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][7]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][8]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][9]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][10]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][11]);
    graphObj.series[0].data.push(weatherTrend.rainfall[0][12]);
    graphObj.series[1].data = [];
    graphObj.series[1].data.push(weatherTrend.temp[0][1]);
    graphObj.series[1].data.push(weatherTrend.temp[0][2]);
    graphObj.series[1].data.push(weatherTrend.temp[0][3]);
    graphObj.series[1].data.push(weatherTrend.temp[0][4]);
    graphObj.series[1].data.push(weatherTrend.temp[0][5]);
    graphObj.series[1].data.push(weatherTrend.temp[0][6]);
    graphObj.series[1].data.push(weatherTrend.temp[0][7]);
    graphObj.series[1].data.push(weatherTrend.temp[0][8]);
    graphObj.series[1].data.push(weatherTrend.temp[0][9]);
    graphObj.series[1].data.push(weatherTrend.temp[0][10]);
    graphObj.series[1].data.push(weatherTrend.temp[0][11]);
    graphObj.series[1].data.push(weatherTrend.temp[0][12]);
    setWeatherTrendChartOptions(graphObj);
  };

  const caclCreditScore = (data, key, dividend, sectionScore) => {
    let score_increaser = (sectionScore / dividend);
    let updatedScore = 0;
    let breakup = { ...scoreBreakup };
    if (key == "basic_details") 
      {
      breakup.basicDetails.name = 0;
      breakup.basicDetails.address = 0;
      breakup.basicDetails.khasra = 0;
      // breakup.basicDetails.numberOfFarmlands = 0;
      // breakup.basicDetails.totalFarmlandArea = 0;
      // breakup.basicDetails.validation = 0;
      if (data[0]?.farmer_name != null && data[0]?.farmer_name != "") {
        updatedScore += score_increaser;
        breakup.basicDetails.name = 10;
      }
      if (data[0]?.village_name != null && data[0]?.village_name != "") {
        updatedScore += 10 / 4;
        breakup.basicDetails.address += 10 / 4;
      }
      if (data[0]?.district_name != null && data[0]?.district_name != "") {
        updatedScore += 10 / 4;
        breakup.basicDetails.address += 10 / 4;
      }
      if (
        data[0]?.subdistrict_name != null &&
        data[0]?.subdistrict_name != ""
      ) {
        updatedScore += 10 / 4;
        breakup.basicDetails.address += 10 / 4;
      }
      if (data[0]?.state_name != null && data[0]?.state_name != "") {
        updatedScore += 10 / 4;
        breakup.basicDetails.address += 10 / 4;
      }
      // if (data[0]?.number_of_farmlands != null) {
      //   updatedScore += score_increaser;
      //   breakup.basicDetails.numberOfFarmlands = 5;
      // }
      // if (data[0]?.total_farmland_area != null) {
      //   updatedScore += score_increaser;
      //   breakup.basicDetails.totalFarmlandArea = 5;
      // }
      if (data[0]?.khasra != null && data[0]?.khasra!=="") {
        updatedScore += score_increaser;
        breakup.basicDetails.khasra = 10;
      }
      updatedScore += 10;
      // breakup.basicDetails.validation = 5;
      setBasicDetailScore(updatedScore);
      setScoreBreakup(breakup);
    }

    if (key == "crop_history") {
      breakup.cropHistory.cropGrowingFactor = 0;

      for (let item in data) {
        if (
          getMajorCropSown(data[item].crop_history) != "--" &&
          getMajorCropSown(data[item].crop_history) != null
        ) {
          updatedScore += score_increaser;
          breakup.cropHistory.cropGrowingFactor += score_increaser;
        }
        setFarmlandDetailScore(updatedScore);
        setScoreBreakup(breakup);
      }
    }
    if (key == "crop_yield") {
      scoreBreakup.cropHistory.yieldFactor =0
      for (let item in data) {
        if (
          getMajorYield(data[item].crop_yield) != "--" &&
          getMajorYield(data[item].crop_yield) != null
        ) {
          let yieldObj = getMajorYield(data[item].crop_yield);

          if (
            yieldObj.maxFarmLevelCropYield <= yieldObj.minDistrictLevelCropYield
          ) {
            scoreBreakup.cropHistory.yieldFactor += 1.0;
            updatedScore += 1.0;
          } else if (
            yieldObj.minFarmLevelCropYield >= yieldObj.minDistrictLevelCropYield
          ) {
            scoreBreakup.cropHistory.yieldFactor += 5.0;
            updatedScore += 5.0;
          } else {
            scoreBreakup.cropHistory.yieldFactor += 3.0;
            updatedScore += 3.0;
          }
        } else {
          scoreBreakup.cropHistory.yieldFactor -= 2;
          updatedScore -= 2;
        }

        setYieldScore(updatedScore);
        setScoreBreakup(breakup);
      }
    }
if (key === "profit_loss_estimates") {
  let plObj = data.profit_loss_estimates[0];
  updatedScore = 0;
  breakup.profitLoss.cropHealth = 0;
  breakup.profitLoss.soilHealth = 0;
  breakup.profitLoss.farmIncome = 0;

  let cropCount = 0;
  let cropSum = 0;

  Object.values(plObj).forEach((yearArray) => {
    if (!Array.isArray(yearArray)) return;
    yearArray.forEach((item) => {
      // ---------- CROP HEALTH ----------
      if (item.crop_health != null) {
        cropCount++;
        const ch = (item.crop_health || "").toLowerCase();
        let score = 3;
        if (ch === "good") score = 4.5;
        else if (ch === "moderate" || ch === "average") score = 3;
        else if (ch === "low" || ch === "poor") score = 1;
        cropSum += score;
        breakup.profitLoss.cropHealth += score;
      }

      // ---------- SOIL HEALTH  ----------
      const sh = (item.soil_health || "").toLowerCase();
      if (sh === "good") {
        updatedScore += 3;
        breakup.profitLoss.soilHealth += 3;
      } else if (sh === "moderate" || sh === "average") {
        updatedScore += 2;
        breakup.profitLoss.soilHealth += 2;
      } else if (sh === "low" || sh === "poor") {
        updatedScore += 1;
        breakup.profitLoss.soilHealth += 1;
      }

      // ---------- FARM INCOME----------
      if (
        item.estimated_cost_of_production != null &&
        item.expected_gross_margins != null
      ) {
        const profit =
          (item.expected_gross_margins - item.estimated_cost_of_production) /
          item.estimated_cost_of_production;

        if (profit > 30) {
          updatedScore += 9;
          breakup.profitLoss.farmIncome += 9;
        } else if (profit > 10 && profit <= 30) {
          updatedScore += 6;
          breakup.profitLoss.farmIncome += 6;
        } else if (profit > 0 && profit <= 10) {
          updatedScore += 3;
          breakup.profitLoss.farmIncome += 3;
        }
      }
    });
  });

  let averageCropHealth = 0;
  if (cropCount > 0) {
    averageCropHealth = cropSum / cropCount;
  }
  updatedScore += averageCropHealth;
  breakup.profitLoss.cropHealth = averageCropHealth;
  setProfitLossDetailScore(updatedScore);
  setScoreBreakup(breakup);
}


    if (key == "risk_profile") {
      breakup.riskProfile.cropSuitability = 0;
      breakup.riskProfile.cropExpertise = 0;
      breakup.riskProfile.farmManagement = 0;
      breakup.riskProfile.weatherFloodRisk = 0;
      data?.risk_profile.forEach((item) => {
        if (item?.cropSuitability == "Suitable") {
          updatedScore += 4 / data.risk_profile.length;
          breakup.riskProfile.cropSuitability = 4 / data.risk_profile.length;
        }
        if (item?.currentCropExperties == "High") {
          updatedScore += 4 / data.risk_profile.length;
          breakup.riskProfile.cropExpertise = 4 / data.risk_profile.length;
        } else if (item?.currentCropExperties == "Low") {
          updatedScore += 1 / data.risk_profile.length;
          breakup.riskProfile.cropExpertise = 1 / data.risk_profile.length;
        } else if(item?.currentCropExperties == "Medium") {
          updatedScore += 3 / data.risk_profile.length;
          breakup.riskProfile.cropExpertise = 3 / data.risk_profile.length;
        }
        else{
          updatedScore += 0 / data.risk_profile.length;
          breakup.riskProfile.cropExpertise = 0 / data.risk_profile.length;
        }

        if (item?.farmManagement == "Good") {
          updatedScore += 4 / data.risk_profile.length;
          breakup.riskProfile.farmManagement = 4 / data.risk_profile.length;
        } else if (item?.farmManagement == "Poor") {
          updatedScore += 1 / data.risk_profile.length;
          breakup.riskProfile.farmManagement = 1 / data.risk_profile.length;
        } else if(item?.farmManagement == "Average"){
          updatedScore += 3 / data.risk_profile.length;
          breakup.riskProfile.farmManagement = 3 / data.risk_profile.length;
        }
        else{
          updatedScore += 0 / data.risk_profile.length;
          breakup.riskProfile.farmManagement = 0 / data.risk_profile.length;
        }

        if (item?.weatherRisk == "High") {
          updatedScore += 0.5 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 0.5 / data.risk_profile.length;
        } else if (item?.weatherRisk == "Low") {
          updatedScore += 2 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 2 / data.risk_profile.length;
        } else if (item?.weatherRisk == "Medium") {
          updatedScore += 1.5 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 1.5 / data.risk_profile.length;
        }
        else{
          updatedScore += 0 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 0 / data.risk_profile.length;
        }

        if (item?.FloodRisk == "High") {
          updatedScore += 0.5 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 0.5 / data.risk_profile.length;
        } else if (item?.FloodRisk == "Low") {
          updatedScore += 2 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 2 / data.risk_profile.length;
        } else if (item?.FloodRisk == "Medium"){
          updatedScore += 1.5 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 1.5 / data.risk_profile.length;
        }
        else{
          updatedScore += 0 / data.risk_profile.length;
          breakup.riskProfile.weatherFloodRisk += 0 / data.risk_profile.length;
        }
        setScoreBreakup(breakup);
        setRiskDetailScore(updatedScore);
      });
    }
  };

  const getCropHealthColor=(cropHealth)=>{
    if(cropHealth === "Poor"){
      return "rgb(249, 121, 121)"
    }
    else if (cropHealth === "Good"){
      return "rgb(176, 232, 150)"
    }
    else if (cropHealth === "Moderate"){
      return "rgb(249, 255, 194)"
    }
    return "--"
  }
/*
  useEffect(() => {
    let chartObj = { ...creditChartOptions };
    let updatedScore = Math.round(
      basicDetailScore +
        landDetailScore +
        farmlandDetailScore +
        profitLossDetailScore +
        riskDetailScore +
        yieldScore
    );
    setTotalCreditScore(updatedScore);

    chartObj.series[0].data[0] = updatedScore;
    chartObj.title.text = "";
    setCreditChartOptions(chartObj);
  }, [
    basicDetailScore,
    farmlandDetailScore,
    profitLossDetailScore,
    riskDetailScore,
    yieldScore,
  ]);
*/


useEffect(() => {
  const basicScore =
    Number(basicDetailsScore?.total?.value) || 0;

  const profitLossScore =
    Number(profitLossDetailsScore?.total?.value) || 0;

  const riskScore =
    Number(riskProfileDetailsScore?.total?.value) || 0;

  const yieldScore =
    Number(cropHistoryDetailsScore?.total?.value) || 0;

  let chartObj = { ...creditChartOptions };

  const updatedScore = Math.round(
    basicScore +
      profitLossScore +
      riskScore +
      yieldScore
  );

  setTotalCreditScore(updatedScore);

  chartObj.series[0].data[0] = updatedScore;
  chartObj.title.text = "";

  setCreditChartOptions(chartObj);
}, [
  basicDetailsScore,
  profitLossDetailsScore,
  riskProfileDetailsScore,
  cropHistoryDetailsScore,
]);
  useEffect(() => {
    if (basicDetails && Object.keys(basicDetails).length) {
      caclCreditScore(basicDetails, "basic_details", 6, 30);
      // if (featureType !== "farms") {
      //   caclCreditScore(
      //     farmersScore,
      //     "land_details",
      //     3 * farmersScore.land_details.length
      //   );
      // }
    }
  }, [basicDetails]);

  useEffect(() => {
    if (cropHistory && Object.keys(cropHistory).length>0) {
      caclCreditScore(cropHistory, "crop_history", 3, 15);
      caclCreditScore(cropHistory, "crop_yield", 3, 15);
    }
  }, [cropHistory]);

  useEffect(() => {
    if (riskProfile && Object.keys(riskProfile).length) {
      caclCreditScore(riskProfile, "risk_profile", 4, 14);
    }
  }, [riskProfile]);

useEffect(() => {
  if (profitLoss && Object.keys(profitLoss).length) {
      updateCashFlowChart();
      caclCreditScore(profitLoss, "profit_loss_estimates", 4, 24);
    const cropObj = profitLoss?.profit_loss_estimates?.[0];
    let profit = 0;
    Object.values(cropObj || {}).forEach((yearArray) => {
      if (Array.isArray(yearArray)) {
        yearArray.forEach((crop) => {
          profit += crop?.expected_gross_margins || 0;
        });
      }
    });
    setTotalProfit(profit);
  }
}, [profitLoss]);

  useEffect(() => {
    if (Object.keys(weatherTrend)?.length) {
      updateWeatherTrendChart();
    }
  }, [weatherTrend]);

  const loadingMessage = () => {
    messageApi.open({
      type: "loading",
      content: "Your file is being ready, Please wait..",
      duration: 1.5,
    });
  };

  // GENERATE A MESSAGE WHEN REPORT IS READY TO DOWNLOAD (FARMER SCORE CARD)

  const successMessage = () => {
    messageApi.open({
      type: "success",
      content: "Your file is ready to download.",
      duration: 2,
    });
  };

  const callPdfService = async (data) => {
    let res = await postData("indexhost", "getPdf", data, null);
    const linkSource = `data:application/pdf;base64,${res.data.data}`;
    const downloadLink = document.createElement("a");
    const fileName = `${basicDetails[0].farmer_name}_${basicDetails[0].village_name}_${basicDetails[0].subdistrict_name}_${basicDetails[0].district_name}_${basicDetails[0].state_name}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    messageApi.destroy();
    successMessage();
    setMapLoader(false);
    downloadLink.click();
  };

  const downloadPdf = async () => {
    loadingMessage();
    setMapLoader(true);
    let target = document.getElementById("divToPrint");
    var wrap = document.createElement("div");
    wrap.appendChild(target.cloneNode(true));

    let startHtml = `<html> <head> <link rel='preconnect' href="https://fonts.googleapis.com" /> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin /> <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;400;500;600;700&display=swap" rel="stylesheet" /> <style> div { font-family: poppins; } p { font-family: poppins; } span { font-family: poppins; } </style> </head> <body>`;
    let endHtml = `</body></html>`;
    let str = startHtml + wrap.innerHTML.replace(/\n|\t/g, " ") + endHtml;
    
    let data = {
      html: encode(str),
    };
    callPdfService(data);
  };
 
  const formatSeasonString = (str) => {
    let str_arr = str.split("_");

    if (str_arr.length > 2) {
      return (
        str_arr[0] +
        "_" +
        str_arr[1].substring(2) +
        " " +
        str_arr[2].charAt(0)?.toUpperCase() +
        str_arr[2].slice(1)
      );
    } else {
      return (
        str_arr[0] +
        "_" +
        str_arr[1].charAt(0)?.toUpperCase() +
        str_arr[1].slice(1)
      );
    }
  };


  const [revenue, setRevenue] = useState(false);
  const validateRevenue = async (e) => {
    let data = {
      data: 6,
      is_validated: 1,
      id: basicDetails.id ? basicDetails.id : basicDetails[0].id,
    };

    let res = await postData("score", "validation", data, null);
    if (e.target.checked == true) {
      setRevenue(true);
    }
  };

const getMajorCropSowingOfTotalSowingPercentage = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return "--";
  const totalSowing = arr.reduce((sum, item) => sum + (item.value || 0), 0);
  if (totalSowing === 0) return "--";
  const majorCropValue = Math.max(...arr.map((item) => item.value || 0));
  const percentage = (majorCropValue / totalSowing) * 100;
  return isFinite(percentage) ? percentage.toFixed(2) : "--";
};

const formatNewSeasonString = (str) => 
  str.replace(/_([a-z]+)$/, (_, s) => " " + s.charAt(0).toUpperCase() + s.slice(1));

const getCropSowingPercentageList = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return [];
  const totalAreaSum = arr.reduce((sum, crop) => sum + (crop.value || 0), 0);
  const totalFieldArea = arr[0]?.total_field_area || 1;
  const useSum = totalAreaSum > totalFieldArea;
  return arr.map((crop) => {
    const area = crop.value || 0;

    let percent = 0;

    if (useSum) {
      percent = (area / totalAreaSum) * 100;
    } else {
      percent = (area / totalFieldArea) * 100;
    }
    return {
      name: crop.name,
      percent: percent.toFixed(2),
    };
  });
};


const getYieldBgColor = (crop) => {
  const maxFarmYield = Number(crop?.maxFarmLevelCropYield);
  const minFarmYield = Number(crop?.minFarmLevelCropYield);
  const maxDistrictYield = Number(crop?.maxDistrictLevelCropYield);
  const minDistrictYield = Number(crop?.minDistrictLevelCropYield);

  const farmAvgYield = (maxFarmYield + minFarmYield) / 2;
  const districtAvgYield = (maxDistrictYield + minDistrictYield) / 2;

  const yieldXvalue = minDistrictYield - (0.2 * minDistrictYield);

  if (!farmAvgYield || isNaN(farmAvgYield)) return "#F97979";  
  if (farmAvgYield <= yieldXvalue) return "#F97979";  
  if (farmAvgYield >= districtAvgYield) return "#B0E896";  

  return "#F9FFC2";
};

const getLongLat = (data) => {
  if (Array.isArray(data) && data.length === 2) {
    return {
      long: data[0],
      lat: data[1],
    };
  }
  if (
    data &&
    typeof data === "object" &&
    "latitude" in data &&
    "longitude" in data
  ) {
    return {
      long: data.longitude,
      lat: data.latitude,
    };
  }

  return null;
};


  return (
    <Fragment>
      <div>
        {contextHolder}
        <Tooltip title="Download" placement="right">
          <CloudDownloadOutlined
            onClick={downloadPdf}
            style={{
              color: "#212121",
              fontSize: "25px",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </div>
      <div style={{ marginTop: "25px" }} id="divToPrint">
        <div
          style={{
            backgroundImage: `url(https://agribhumi.s3.ap-south-1.amazonaws.com/scorecard_bg_1.svg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "637px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "10px",
          }}
        >
          <img
            src={"https://agribhumi.s3.ap-south-1.amazonaws.com/logo.svg"}
            width="100px"
          />
          {basicDetails&& Object.keys(basicDetails).length ? (
            <div>
              <div>
                <div
                  style={{
                    borderTop: "1px solid #ffffff",
                    borderBottom: "1px solid #ffffff",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      borderRight: "1px solid #ffffff",
                      width: "50%",
                      padding: "10px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Name of the Farmer :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.farmer_name
                            ? basicDetails.farmer_name
                            : basicDetails[0]?.farmer_name
                            ? basicDetails[0]?.farmer_name
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Village :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.village_name
                            ? basicDetails.village_name
                            : basicDetails[0]?.village_name
                            ? basicDetails[0]?.village_name
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Tehsil/Block :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.subdistrict_name
                            ? basicDetails.subdistrict_name
                            : basicDetails[0]?.subdistrict_name
                            ? basicDetails[0]?.subdistrict_name
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "50%",
                      padding: "10px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          District :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.district_name
                            ? basicDetails.district_name
                            : basicDetails[0]?.district_name
                            ? basicDetails[0]?.district_name
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          State :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.state_name
                            ? basicDetails.state_name
                            : basicDetails[0]?.state_name
                            ? basicDetails[0]?.state_name
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Farm/Khasra Number :{" "}
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.khasra
                            ? basicDetails.khasra
                            : basicDetails[0]?.khasra
                            ? basicDetails[0]?.khasra
                            : "Not Available"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid #ffffff",
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      borderRight: "1px solid #ffffff",
                      width: "50%",
                      padding: "10px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Selected Farmland Area :
                        </p>
                      </div>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails?.selected_farmland_area
                            ? parseFloat(
                                basicDetails.selected_farmland_area
                              ).toFixed(3)
                            : basicDetails[0]?.selected_farmland_area
                            ? parseFloat(
                                basicDetails[0]?.selected_farmland_area
                              ).toFixed(3)
                            : "Not Available"}{" "}
                          HA
                        </p>
                      </div>
                    </div>

                          <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Soil Type:
                        </p>
                      </div>

                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                          {basicDetails[0]?.soil_type ? basicDetails[0]?.soil_type : "Not Available"}
                        </p>
                      </div>

                    </div>
                  </div>
                  <div
                    style={{
                      width: "50%",
                      padding: "10px",
                    }}
                  >
                    {/* ---------CURRENT SEASON DETAILS--------- */}
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Current Season :{" "}
                        </p>
                      </div>

                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>
                         {basicDetails[0]?.current_season ? formatNewSeasonString(basicDetails[0]?.current_season) : "Not Available"}
                        </p>
                      </div>
                    </div>
                   {/* -----------CURRENT CROP DETAILS---------- */}
                       <div style={{ display: "flex" }}>
                      <div style={{ width: "50%" }}>
                        <p style={{ fontWeight: 600, fontSize: "18px" }}>
                          Current Crops :
                        </p>
                      </div>

                      <div style={{ width: "50%" }}>
                        <p style={{ fontSize: "18px" }}>

                          {basicDetails?.[0]?.current_crops == null
                            ? "Not Available"
                            : basicDetails[0].current_crops.join(", ")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", marginTop: "20px" }}>
                <div style={{ marginLeft: "40px" }}>
                  <p
                    style={{
                      color: "#ffffff",
                      fontSize: "18px",
                      fontWeight: 700,
                    }}
                  >
                    Report <br /> Generation Date :
                  </p>
                  <p>{moment(new Date()).format("DD MMM, YYYY hh:mm:ss")}</p>
                  <hr color="#212121" />
                </div>
                <div style={{ marginLeft: "40px" }}>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "530px",
              }}
            >
              <img src={`${aws_s3_url}/score-card-loader.gif`} width="60px" />
            </div>
          )}
        </div>

        <div
          style={{
            backgroundImage: `url(https://agribhumi.s3.ap-south-1.amazonaws.com/scorecard_bg_2.svg)`,
            backgroundSize: "cover",
            height: "590px",
            marginTop: "40px",
            pageBreakAfter: "always",
          }}
        >
          <div style={{ display: "flex" }}>
            <p style={{ color: "#585757", fontSize: "30px", fontWeight: 700 }}>
              Credit Score
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "67%",
              }}
            >
              <span style={{ marginTop: "12px", marginRight: "8px" }}>
              Farmer's Credit Score 
              </span>{" "}
              <span
                style={{
                  color: "#5DD835",
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                {totalCreditScore}/100
              </span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "130px",
            }}
          >
            <div
              style={{
                width: "300px",
                border: "3px solid #263238",
                borderRadius: "5px",
                marginTop: "9%",
                marginLeft: "25%",
              }}
            >
              <div style={{ height: "30px", backgroundColor: "#263238" }}></div>
              <HighchartsReact
                highcharts={Highcharts}
                options={creditChartOptions}
              />
              <div
                style={{
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  padding: "6px",
                  borderTop: "1px solid #424242",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "4px",
                      backgroundColor: "#DF5353",
                    }}
                  ></div>
                  Poor: 0-30
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "4px",
                      marginLeft: "4px",
                      backgroundColor: "#DDDF0D",
                    }}
                  ></div>
                  Average: 30-60
                </div>
              </div>
              <div
                style={{
                  paddingLeft: "6px",
                  backgroundColor: "#ffffff",
                  paddingBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "4px",

                      backgroundColor: "#55BF3B",
                    }}
                  ></div>
                  Good: 60-80
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      marginLeft: "4px",
                      marginRight: "4px",
                      backgroundColor: "#3b8529",
                    }}
                  ></div>
                  Excellent: 80-100
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "25px" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p className="section-heading">Farm Location</p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <p style={{ fontFamily: "Poppins" }}>
              Google coordinates to visit the farm: long, lat:&nbsp;
              {(() => {
                const longLat = getLongLat(coordinatesData);
                return longLat ? (
                  <a
                    href={`https://www.google.com/maps?q=${longLat.lat},${longLat.long}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1976d2", textDecoration: "none" }}
                  >
                    ({longLat.long}, {longLat.lat})
                  </a>
                ) : (
                  "Not Available"
                );
              })()}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div className="farm-img-box">
              {Object.keys(googgleImages).length ? (
                <img
                  src={`data:image/png;base64,${googgleImages["satellite"]}`}
                  width="100%"
                />
              ) : (
                <img src={`${aws_s3_url}/score-card-loader.gif`} width="60px" />
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                }}
              >
                <p
                  style={{
                    marginBottom: "0px",
                    color: "#585757",
                    fontFamily: "Poppins",
                  }}
                >
                  Farm Khasra Boundary
                </p>
              </div>
            </div>
            <div className="farm-img-box">
              {Object.keys(googgleImages).length ? (
                <img
                  src={`data:image/png;base64,${googgleImages["open-street-map"]}`}
                  width="100%"
                />
              ) : (
                <img src={`${aws_s3_url}/score-card-loader.gif`} width="60px" />
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                }}
              >
                <p
                  style={{
                    marginBottom: "0px",
                    color: "#585757",
                    fontFamily: "Poppins",
                  }}
                >
                  Farm location from nearest road
                </p>
              </div>
            </div>
          </div>
        </div>

   <div style={{ marginTop: "50px", pageBreakAfter: "always" }}>
  <p
    style={{
      color: "#585757",
      fontSize: "30px",
      fontWeight: 600,
      fontFamily: '"Poppins"',
    }}
  >
    Crop History
  </p>
  <p
    style={{
      color: "#585757",
      fontSize: "18px",
      fontFamily: "Poppins",
    }}
  >
    Farmland {cropHistory?.Khasra || "N/A"}
  </p>

          <div
            style={{
              border: "1px solid #e6e6e6",
              boxShadow: "0px 4px 12px 0px #b4b4b440",
            }}
          >
            <div style={{ display: "flex", borderBottom: "1px solid #e6e6e6" }}>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                Season
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                Total Sowing (Ha)
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                Crops Sown
              </div>
              {/* <div
        style={{
          borderRight: "1px solid #e6e6e6",
          width: "15%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
          color: "#585757",
          fontWeight: 700,
        }}
      >
        Major Crop
      </div> */}
              {/* <div
        style={{
          borderRight: "1px solid #e6e6e6",
          width: "15%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
          color: "#585757",
          fontWeight: 700,
        }}
      >
        Major Crop Sowing (%) of Total Sowing
      </div> */}
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                Sowing (%)

              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                District Level Avg. Crop Yield (Qtl/Ha)
              </div>
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontWeight: 700,
                }}
              >
                Farm Level Crop Yield (Qtl/Ha)
              </div>
            </div>

            {/* Table Rows */}
            {cropHistory && Object.keys(cropHistory).length > 0 ? (
              Object.entries(cropHistory).map(
                (item, index) =>
                  item[0] !== "Khasra" &&
                  item[0] !== "score" && (
                  
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        borderBottom: "1px solid #e6e6e6",
                      }}
                    >
                      {/* Season */}
                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "15%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#000",
                        }}
                      >
                        {formatSeasonString(item[0]) || "N/A"}
                      </div>

                      {/* Total Sowing */}
                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "15%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          backgroundColor: basicDetails.length
                            ? getTotalSowingPercentage(item[1].crop_history) > 70
                              ? "#B0E896"
                              : getTotalSowingPercentage(item[1].crop_history) > 50
                                ? "#F9FFC2"
                                : "#F97979"
                            : "transparent",
                        }}
                      >
                        {basicDetails.length ? getTotalSowing(item[1].crop_history) : "-"}
                      </div>

                      {/* All Crops Sown
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                }}
              >

                {Array.isArray(item[1]?.crop_history) && item[1].crop_history.length > 0
                  ? item[1].crop_history
                    .filter((c) => c?.name && c.name !== "No Crop")
                    .map((c) => c.name)
                    .join(", ") || "--"
                  : "--"}
              </div> */}

                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "20%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#585757",
                          position: "relative",
                          borderLeft: "1px solid #e6e6e6",
                        }}
                      >
                        {Array.isArray(item[1]?.crop_history) && item[1].crop_history.length > 0 ? (
                          (() => {
                            const crops = item[1].crop_history.filter(
                              (c) => c?.name && c.name !== "No Crop"
                            );

                            if (crops.length === 0) return "--";
                            if (crops.length === 1) return crops[0].name;
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                {crops.map((c, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      padding: "4px 0px",
                                      borderBottom: "1px solid #e6e6e6",
                                      width: "100%",
                                      justifyContent: "center",

                                    }}
                                  >
                                    {c.name}
                                  </div>
                                ))}
                              </div>
                            );
                          })()
                        ) : (
                          "--"
                        )}
                      </div>
                      {/* Major Crop */}
                      {/* <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                }}
              >
                {getMajorCropSown(item[1].crop_history) || "N/A"}
              </div> */}


                      {/* Major Crop Sowing % */}
                      {/* <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                }}
              >
                {getMajorCropSowingOfTotalSowingPercentage(item[1].crop_history) || "-"}
              </div> */}

                      {/* ----------------Crop Sowing %---`----------- */}
                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "20%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#585757",
                          position: "relative",
                          borderLeft: "1px solid #e6e6e6",
                        }}
                      >
                        {Array.isArray(item[1]?.crop_history) && item[1].crop_history.length > 0 ? (
                          (() => {
                            const crops = item[1].crop_history.filter(
                              (c) => c?.name && c.name !== "No Crop"
                            );
                            if (crops.length === 0) return "--";
                            const sowingList = getCropSowingPercentageList(crops);
                            if (sowingList.length === 1) {
                              return `${Math.trunc(sowingList[0].percent)}`;
                            }

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                {sowingList.map((c, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      padding: "4px 0px",
                                      width: "100%",
                                      justifyContent: "center",
                                      borderBottom:
                                        idx !== sowingList.length - 1
                                          ? "1px solid #e6e6e6"
                                          : "none",
                                    }}
                                  >
                                   {Math.trunc(c.percent)}
                                  </div>
                                ))}
                              </div>
                            );
                          })()
                        ) : (
                          "--"
                        )}
                      </div>
                      {/* Major Crop Avg District Level */}
                      {/* <div
                style={{
                  borderRight: "1px solid black",
                  borderTop: "1px solid black",

                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                }}
              >
                {getMajorYield(item[1].crop_yield)?.minDistrictLevelCropYield}-
                {getMajorYield(item[1].crop_yield)?.maxDistrictLevelCropYield || "--"}
              </div> */}
                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "15%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#585757",
                          position: "relative",
                          borderLeft: "1px solid #e6e6e6",
                        }}
                      >
                        {Array.isArray(item[1]?.crop_yield) && item[1].crop_yield.length > 0 ? (
                          (() => {
                            const yields = item[1].crop_yield;

                            if (yields.length === 0) return "--";

                            const safeValue = (v) =>
                              v === null || v === undefined || v === "" || Number.isNaN(v)
                                ? "--"
                                : v;

                            if (yields.length === 1) {
                              const min = safeValue(yields[0].minDistrictLevelCropYield);
                              const max = safeValue(yields[0].maxDistrictLevelCropYield);
                              return `${min} - ${max}`;
                            }
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                {yields.map((y, idx) => {
                                  const min = safeValue(y.minDistrictLevelCropYield);
                                  const max = safeValue(y.maxDistrictLevelCropYield);

                                  return (
                                    <div
                                      key={idx}
                                      style={{
                                        padding: "4px 0px",
                                        width: "100%",
                                        justifyContent: "center",
                                        borderBottom:
                                          idx !== yields.length - 1
                                            ? "1px solid #e6e6e6"
                                            : "none",
                                      }}
                                    >
                                      {min} - {max}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })()
                        ) : (
                          "--"
                        )}
                      </div>
                      {/* Major Crop Avg Yield This Farm */}
                      {/* <div
                style={{
                  borderRight: "1px solid black",
                  borderTop: "1px solid black",
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  backgroundColor: handleYieldBgColor(item[1].crop_yield),
                }}
              >
                {getMajorYield(item[1].crop_yield) !== "--"
                  ? (
                    ((getMajorYield(item[1].crop_yield)?.maxFarmLevelCropYield || 0) +
                      (getMajorYield(item[1].crop_yield)?.minFarmLevelCropYield || 0)) / 2
                  ).toFixed(2)
                  : "--"}
              </div> */}
                      <div
                        style={{
                          borderTop: "1px solid #11111166",
                          width: "15%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#585757",
                          position: "relative",
                          borderLeft: "1px solid #e6e6e6",
                        }}
                      >
                        {Array.isArray(item[1]?.crop_yield) && item[1].crop_yield.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "center",
                              width: "100%"
                            }}
                          >
                            {item[1].crop_yield.map((c, idx) => {
                              const min = c?.minFarmLevelCropYield;
                              const max = c?.maxFarmLevelCropYield;

                              const isValid =
                                min != null &&
                                max != null &&
                                !isNaN(min) &&
                                !isNaN(max) &&
                                min !== 0 &&
                                max !== 0;

                              const avg = isValid ? ((min + max) / 2).toFixed(2) : "--";

                              return (
                                   <div
                                  key={idx}
                                  style={{
                                    padding: "4px 0px",
                                    width: "100%",
                                    justifyContent: "center",
                                    backgroundColor: getYieldBgColor(c),
                                    borderBottom:
                                      idx !== avg.length - 1
                                        ? "1px solid #e6e6e6"
                                        : "none",
                                  }}
                                >
                                  {avg}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          "--"
                        )}
                      </div>

                    </div>
          )
      )
    ) : (
      <div
        style={{
          background: "rgb(249, 121, 121)",
          border: "1px solid rgb(230, 230, 230)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "9px",
        }}
      >
        <Typography>Loading</Typography>
      </div>
    )}

    {/* Legend */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "20px 15px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            backgroundColor: "#B0E896",
            border: "1px solid #27BA5C",
            width: "20px",
            height: "20px",
            marginRight: "5px",
          }}
        ></div>
        Sowing in more than 70% area or high yield
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            backgroundColor: "#F9FFC2",
            border: "1px solid #E3AE10",
            width: "20px",
            height: "20px",
            marginRight: "5px",
          }}
        ></div>
        Sowing in 50-70% area or average yield
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            backgroundColor: "#F97979",
            border: "1px solid #ED1849",
            width: "20px",
            height: "20px",
            marginRight: "5px",
          }}
        ></div>
        Sowing in less than 50% area or low yield
      </div>
    </div>
  </div>
</div>


        <div style={{ marginTop: "50px" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Yearly Profit & Loss Estimates
          </p>
          <div
            style={{
              border: "1px solid #e6e6e6",
              boxShadow: "0px 4px 12px 0px #b4b4b440",
            }}
          >
            <div style={{ display: "flex", borderBottom: "1px solid #e6e6e6" }}>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                Farm No
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                Season
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                Crops Sown
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                Crop Health
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                Soil Health
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                <p>Estimated Production at this farm (qt)</p>
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                <p>Estimated value of Produce(INR)</p>
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                <p>Estimated Cost of Production(INR)</p>
              </div>
              <div
                style={{
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                <p>Estimated Cost of Inputs Required(INR)</p>
              </div>
              <div
                style={{
                  fontWeight: 700,
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  color: "#585757",
                  fontSize: "11px",
                }}
              >
                <p>Expected Gross Margin (INR)</p>
              </div>
            </div>

            {profitLoss && Object.keys(profitLoss).length ? (
              <>
                {Object.entries(profitLoss?.profit_loss_estimates[0]).map(([key, value], index) => {
                  const first = Array.isArray(value) && value.length > 0 ? value[0] : value;
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        borderBottom: "1px solid #e6e6e6",
                      }}
                    >
                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 700,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {first?.khasra ?? "--"}
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 700,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {formatSeasonString(key)}
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        <span>
                          {Array.isArray(value)
                            ? value.map(c => c.crop).filter(Boolean).join(", ") || "--"
                            : first?.crop ?? "--"}
                        </span>
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          backgroundColor: getCropHealthColor(first?.crop_health),
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {first?.crop_health ?? "--"}
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          backgroundColor: "#F97979",
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {first?.soil_health ?? "--"}
                      </div>
                     
                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {/* {Array.isArray(value)
                          ? 
                            value.reduce(
                              (sum, crop) => sum + (crop.estimated_production || 0),
                              0
                          )
                          : first?.estimated_production
                            ? first.estimated_production
                            : "--"} */}
                                     {Array.isArray(value)
                            ? value.map(c => c.estimated_production).filter(Boolean).join(", ") || "--"
                            : first?.estimated_production ?? "--"}
                      </div>


                          <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                        {Array.isArray(value)
                          ? Math.trunc(
                            value.reduce(
                              (sum, crop) => sum + (crop.estimated_value_of_produce || 0),
                              0
                            )
                          )
                          : first?.estimated_value_of_produce
                            ? Math.trunc(first.estimated_value_of_produce)
                            : "--"}
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                          {Array.isArray(value)
                          ? Math.trunc(
                            value.reduce(
                              (sum, crop) => sum + (crop.estimated_cost_of_production || 0),
                              0
                            )
                          )
                          : first?.estimated_cost_of_production
                            ? Math.trunc(first.estimated_cost_of_production)
                            : "--"}
                      </div>

                      <div
                        style={{
                          borderRight: "1px solid #e6e6e6",
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                           {Array.isArray(value)
                          ? Math.trunc(
                            value.reduce(
                              (sum, crop) => sum + (crop.estimated_cost_of_inputs_required || 0),
                              0
                            )
                          )
                          : first?.estimated_cost_of_inputs_required
                            ? Math.trunc(first.estimated_cost_of_inputs_required)
                            : "--"}
                      </div>

                      <div
                        style={{
                          fontWeight: 500,
                          width: "10%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          color: "#585757",
                          fontSize: "11px",
                        }}
                      >
                           {Array.isArray(value)
                          ? Math.trunc(
                            value.reduce(
                              (sum, crop) => sum + (crop.expected_gross_margins || 0),
                              0
                            )
                          )
                          : first?.expected_gross_margins
                            ? Math.trunc(first.expected_gross_margins)
                            : "--"}
                      </div>
                    </div>
                  );
                })}

                {/* TOTAL */}
                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid #e6e6e6",
                  }}
                >
                  <div style={{ width: "80%" }}></div>

                  <div
                    style={{
                      borderRight: "1px solid #e6e6e6",
                      fontWeight: 700,
                      width: "10%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      padding: "10px",
                      color: "#585757",
                      fontSize: "11px",
                    }}
                  >
                    Yearly Farm Income
                  </div>

                  <div
                    style={{
                      borderRight: "1px solid #e6e6e6",
                      fontWeight: 700,
                      width: "10%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "10px",
                      color: "#585757",
                      fontSize: "11px",
                    }}
                  >
                    {totalProfit && !isNaN(totalProfit)
                      ? `${Math.trunc(totalProfit)} Rs`
                      : "--"}
                  </div>
                </div>
              </>
            ) : (
              <div
                style={{
                  background: "rgb(249, 121, 121)",
                  border: "1px solid rgb(230, 230, 230)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "9px",
                }}
              >
                <Typography>Loading</Typography>
              </div>
            )}


            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "20px 15px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: "#B0E896",
                    border: "1px solid #27BA5C",
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                ></div>
                Good crop health, soil health, yield or income
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: "#F9FFC2",
                    border: "1px solid #E3AE10",
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                ></div>
                Average crop health, soil health, yield or income
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: "#F97979",
                    border: "1px solid #ED1849",
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                ></div>
                Poor crop health, soil health, yield or income
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px", pageBreakAfter: "always" }}>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Farmer Cash Flow
          </p>
          <div
            style={{
              border: "1px solid #e6e6e6",
              boxShadow: "0px 4px 12px 0px #B4B4B440",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#9fc088",
                  width: "14px",
                  height: "14px",
                  marginLeft: "5px",
                  marginRight: "15px",
                }}
              ></div>
              <Typography style={{ fontSize: "12px", fontWeight: "bold" }}>
                Income
              </Typography>
              <div
                style={{
                  backgroundColor: "#5C87E9",
                  width: "14px",
                  height: "14px",
                  marginRight: "15px",
                  marginLeft: "30px",
                }}
              ></div>
              <Typography style={{ fontSize: "12px", fontWeight: "bold" }}>
                Expense
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "950px" }}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={cashflowChartOptions}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <p style={{ fontWeight: "bold" }}>
                This graph reflects the average cost of cultivation and average
                income from the farm for the last two seasons.
              </p>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Risk Profile
          </p>
          {riskProfile && Object.keys(riskProfile).length ? (
            <div
              style={{
                border: "1px solid #e6e6e6",
                boxShadow: "0px 4px 12px 0px #b4b4b440",
              }}
            >
              <div
                style={{ display: "flex", borderBottom: "1px solid #e6e6e6" }}
              >
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "10%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Farm No.
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Weather Risk
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Flood Risk
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Crop Heath Risk
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Current Crop Suitability
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Current Crop Expertise
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  Farm Management
                </div>
              </div>
              <div
                style={{ display: "flex", borderBottom: "1px solid #e6e6e6" }}
              >
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    width: "10%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {/* 11/1 */}
                  {riskProfile.khasra}
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 700,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.weatherRisk == "Low"
                        ? "#B0E896"
                        : riskProfile?.risk_profile[0]?.weatherRisk == "High"
                        ? "#F97979"
                        : "#F9FFC2",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.weatherRisk
                    ? riskProfile?.risk_profile[0].weatherRisk
                    : "--"}
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 500,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.FloodRisk == "Low"
                        ? "#B0E896"
                        : riskProfile?.risk_profile[0]?.FloodRisk == "High"
                        ? "#F97979"
                        : "#F9FFC2",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.FloodRisk
                    ? riskProfile?.risk_profile[0].FloodRisk
                    : "--"}
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 500,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.cropHealthRisk == "Low"
                        ? "#B0E896"
                        : riskProfile?.risk_profile[0]?.cropHealthRisk == "High"
                        ? "#F97979"
                        : "#F9FFC2",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.cropHealthRisk
                    ? riskProfile?.risk_profile[0].cropHealthRisk
                    : "--"}
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 500,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.cropHealthRisk == "Suitable"
                        ? "#B0E896"
                        : "#F97979",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.cropSuitability ? (
                    <>
                      {riskProfile?.risk_profile[0].cropSuitability}
                      <span style={{ fontSize: "20px", marginLeft: "3px" }}>*</span>
                    </>
                  ) : (
                    "--"
                  )}

                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 500,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.currentCropExperties == "Low"
                        ? "#F97979"
                        : riskProfile?.risk_profile[0]?.currentCropExperties ==
                          "High"
                        ? "#B0E896"
                        : "#F9FFC2",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.currentCropExperties
                    ? riskProfile?.risk_profile[0].currentCropExperties
                    : "--"}
                </div>
                <div
                  style={{
                    borderRight: "1px solid #e6e6e6",
                    fontWeight: 500,
                    backgroundColor:
                      riskProfile?.risk_profile[0]?.currentCropExperties ==
                      "Good"
                        ? "#B0E896"
                        : riskProfile?.risk_profile[0]?.currentCropExperties ==
                          "Average"
                        ? "#F97979"
                        : "#F9FFC2",
                    width: "15%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    color: "#585757",
                    fontSize: "11px",
                  }}
                >
                  {riskProfile?.risk_profile[0]?.farmManagement
                    ? riskProfile?.risk_profile[0].farmManagement
                    : "--"}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "20px 15px",
                  flexDirection: "column",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#B0E896",
                      border: "1px solid #27BA5C",
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                  ></div>
                  Low weather risk/Low flood risk/Low crop health risk/High crop
                  suitability/High current crop expertise/Good Farm Management
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#F9FFC2",
                      border: "1px solid #E3AE10",
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                  ></div>
                  Moderate weather risk/Moderate flood risk/Medium crop health
                  risk/Medium crop suitability/Moderate current crop
                  expertise/Average Farm Management
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      backgroundColor: "#F97979",
                      border: "1px solid #ED1849",
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                  ></div>
                  High weather risk/High flood risk/High crop health risk/Low
                  crop suitability/Low current crop expertise/Poor Farm
                  Management
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontSize: "20px" }}>*</span>

                  <span>
                    Get Agribhumi Crop Suitability Report of your farm, click here to know more{" "}
                    <a
                      href="https://www.agribazaar.com/contact-us"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.agribazaar.com/contact-us
                    </a>
                  </span>
                </div>

              </div>
            </div>
          ) : (
            <div
              style={{
                background: "rgb(249, 121, 121)",
                border: " 1px solid rgb(230, 230, 230)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "9px",
              }}
            >
              <Typography>NO DATA FOUND</Typography>
            </div>
          )}
        </div>

        <div style={{ marginTop: "50px", pageBreakAfter: "always" }}>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Weather Trend
          </p>
          <div
            style={{
              border: "1px solid #e6e6e6",
              boxShadow: "0px 4px 12px 0px #B4B4B440",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "950px" }}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={weatherTrendChartOptions}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px", pageBreakAfter: "always" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Credit Score Translation Factors
          </p>
          <div style={{ border: "1px solid #e6e6e6" }}>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "25%",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                Points
              </div>
              <div
                style={{
                  width: "20%",
                  borderLeft: "1px solid #e6e6e6",
                  borderRight: "1px solid #e6e6e6",
                  fontSize: "16px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                Section Scored
              </div>
              <div
                style={{
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                  width: "55%",
                  fontSize: "16px",

                }}
              >
                Maximum Score
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  backgroundColor: "#F5FAF5",
                  width: "25%",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      "https://agribhumi.s3.ap-south-1.amazonaws.com/basic-details-icon.svg"
                    }
                    style={{ marginRight: "4px" }}
                  />
                  Basic Details
                </div>
              </div>
              <div
                style={{
                  width: "20%",
                  borderLeft: "1px solid #e6e6e6",
                  borderRight: "1px solid #e6e6e6",
                  fontSize: "16px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* {basicDetailScore} */}
                {basicDetailsScore?.total?.value ?? "--"}
              </div>
              <div
                style={{
                  width: "55%",
                  padding: "10px",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  {/* Farmer Name (Maximum : value) {scoreBreakup?.basicDetails?.name}/10 */}
                  Farmer Name (Maximum : 5) 
                </span>
                <br />
                <span style={{ fontWeight: "bold" }}>
                  Address (Village, Tehsil, District, State) (Maximum : 5) {" "}
                  {/* {scoreBreakup?.basicDetails?.address}/10 */}
                </span>
                <br />
                {/* <span style={{ fontWeight: "bold" }}>Khasra No. = {scoreBreakup?.basicDetails?.khasra}/10</span> */}
                <span style={{ fontWeight: "bold" }}>Khasra No. (Maximum : 5)</span>
                <div>
                  <hr />
                </div>
                {/* <span style={{ fontWeight: "bold" }}>Total = {basicDetailScore}/30</span> */}
                <span style={{ fontWeight: "bold" }}>Maximum Total value: 15</span>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  backgroundColor: "#F5FAF5",
                  width: "25%",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      "https://agribhumi.s3.ap-south-1.amazonaws.com/farmland-icon.svg"
                    }
                    style={{ marginRight: "4px" }}
                  />
                  Farmland Details/ Crop History
                </div>
              </div>
              <div
                style={{
                  width: "20%",
                  borderLeft: "1px solid #e6e6e6",
                  borderRight: "1px solid #e6e6e6",
                  fontSize: "16px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* {yieldScore + farmlandDetailScore} */}
                {cropHistoryDetailsScore?.total?.value ?? "--"}

              </div>
              <div
                style={{
                  width: "55%",
                  padding: "10px",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <span style={{ fontWeight: "bold" }}>
                  Crop Growing Factor {" "}
                  {/* {scoreBreakup.cropHistory.cropGrowingFactor} /15 */}
                  (Maximum : 15)
                </span>
                (Based on No. of Season crop is grown in last 2 years)
                <div>
                  <hr />
                </div>
                {/* <span style={{ fontWeight: "bold" }}>
                  Yield Factor = {scoreBreakup.cropHistory.yieldFactor} /15
                </span>
                ( Based on crop yield in past 3 crop seasons) */}
                <span>
                  <span style={{ fontWeight: "bold" }}>Yield Factor</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on crop yield in past 3 crop seasons)
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 15)</span>
                </span>
                <div>
                  <hr />
                </div>
                <span style={{ fontWeight: "bold" }}>Maximum Total Value: 30</span>
                {/* <span style={{ fontWeight: "bold" }}>Total = {parseInt(scoreBreakup.cropHistory.yieldFactor) + parseInt(scoreBreakup.cropHistory.cropGrowingFactor)}/30  </span> */}
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  backgroundColor: "#F5FAF5",
                  width: "25%",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      "https://agribhumi.s3.ap-south-1.amazonaws.com/p-and-l-icon.svg"
                    }
                    style={{ marginRight: "4px" }}
                  />
                  Profit & Loss Estimates
                </div>
              </div>
              <div
                style={{
                  width: "20%",
                  borderLeft: "1px solid #e6e6e6",
                  borderRight: "1px solid #e6e6e6",
                  fontSize: "16px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* {profitLossDetailScore} */}
                {profitLossDetailsScore?.total?.value ?? "--"}
                
              </div>
              <div
                style={{
                  width: "55%",
                  padding: "10px",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* <span style={{ fontWeight: "bold" }}>
                  Crop health = {scoreBreakup.profitLoss.cropHealth}/9
                </span>{" "}
                ( Based on crop health estimated for past 2 crop seasons ) */}
                   <span>
                  <span style={{ fontWeight: "bold" }}>Crop health</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on crop health estimated for past 2 crop seasons)
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 10)</span>
                </span>
                <div>
                  <hr />
                </div>
                {/* <span style={{ fontWeight: "bold" }}>
                  Soil Health = {scoreBreakup.profitLoss.soilHealth}/6
                </span>{" "}
                ( Based on soil health estimated for past 2 crop seasons ) */}
                     <span>
                  <span style={{ fontWeight: "bold" }}>Soil Health</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on soil health estimated for past 2 crop seasons)
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 10)</span>
                </span>
                <div>
                  <hr />
                </div>
                {/* <span style={{ fontWeight: "bold" }}>
                  Farm Income (max 9) = {scoreBreakup.profitLoss.farmIncome}/9
                </span>
                (Scored 9 if Profit is more than 30%, 6 if Profit is between
                10-30%, 3 if Profit is 0-10%) */}
                       <span>
                  <span style={{ fontWeight: "bold" }}>Farm Income</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on Farm Income from last 02 crop seasons)
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 15)</span>
                </span>
                <div>
                  <hr />
                </div>
                <span style={{ fontWeight: "bold" }}>
                  {/* Total = {profitLossDetailScore}/24 */}
                  Maximum Total Value: 35
                </span>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  backgroundColor: "#F5FAF5",
                  width: "25%",
                  fontSize: "16px",
                  fontWeight: 600,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      "https://agribhumi.s3.ap-south-1.amazonaws.com/risk-profile-icon.svg"
                    }
                    style={{ marginRight: "4px" }}
                  />
                  Risk Profile
                </div>
              </div>
              <div
                style={{
                  width: "20%",
                  borderLeft: "1px solid #e6e6e6",
                  borderRight: "1px solid #e6e6e6",
                  fontSize: "16px",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* {riskDetailScore} */}
                {riskProfileDetailsScore?.total?.value ?? "--"}
              </div>
              <div
                style={{
                  width: "55%",
                  padding: "10px",
                  borderBottom: "1px solid #e6e6e6",
                }}
              >
                {/* <span style={{ fontWeight: "bold" }}>
                  Weather & Flood Risk ={" "}
                  {scoreBreakup.riskProfile.weatherFloodRisk}
                  /4
                </span>{" "}
                ( Best if weather is suitable and there is no chance of flood, worst if both are not suitable ) */}
                <span>
                  <span style={{ fontWeight: "bold" }}>Weather & Flood Risk</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    ( Best if weather is suitable and there is no chance of flood, worst if both are not suitable )
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 8)</span>
                </span>
                <br />
                {/* <span style={{ fontWeight: "bold" }}>
                  Crop Suitability = {scoreBreakup.riskProfile.cropSuitability}
                  /4
                </span>
                ( Based on soil properties, weather data and crop grown in past 2 seasons ) */}
                 <span>
                  <span style={{ fontWeight: "bold" }}>Crop Suitability</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on soil properties, weather data and crop grown in past 2 seasons )
                  </span>{" "}
                  <br />
                  <span style={{ fontWeight: "bold" }}>(Maximum : 4)</span>
                </span>
                <br />{" "}
                {/* <span style={{ fontWeight: "bold" }}>
                  Crop Expertise = {scoreBreakup.riskProfile.cropExpertise}
                  /4{" "}
                </span>
                ( Based upon crop grown in past 2 years) */}
                   <span>
                  <span style={{ fontWeight: "bold" }}>Crop Expertise</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on crop grown in past 2 years)
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 4)</span>
                </span>
                <br />
                {/* <span style={{ fontWeight: "bold" }}>
                  Farm management = {scoreBreakup.riskProfile.farmManagement}/4
                </span>{" "}
               ( Based upon crop performance in past 3 crop seasons ) */}
                   <span>
                  <span style={{ fontWeight: "bold" }}>Farm management</span>{" "}
                  <span style={{ fontWeight: "normal" }}>
                    (Based on crop performance in past 3 crop seasons )
                  </span>{" "}
                  <span style={{ fontWeight: "bold" }}>(Maximum : 4)</span>
                </span>
                <div>
                  <hr />
                </div>
                <span style={{ fontWeight: "bold" }}>
                  {/* Total = {riskDetailScore}/16 */}
                  Maximum Total Value: 20
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}>
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Soil Health Index Table
          </p>
          <div
            style={{
              border: "1px solid #e6e6e6",
              borderRadius: "4px",
              boxShadow: "0px 4px 12px 0px #b4b4b440",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  fontWeight: 600,
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Range
              </div>
              <div
                style={{
                  fontWeight: 600,
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Nitrogen
              </div>
              <div
                style={{
                  fontWeight: 600,
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Phosphorus
              </div>
              <div
                style={{
                  fontWeight: 600,
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Potassium
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#B0E896",
                borderBottom: "1px solid #e6e6e6",
              }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Good
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                226+ kg/acre
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                23+ kg/acre
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                136+ kg/acre
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#F9FFC2",
                borderBottom: "1px solid #e6e6e6",
              }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Average
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                113-226 kg/acre
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                9-23 kg/acre
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                58-136 kg/acre
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "#F97979",
                borderBottom: "1px solid #e6e6e6",
              }}
            >
              <div
                style={{
                  color: "#ffffff",
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                Poor
              </div>
              <div
                style={{
                  color: "#ffffff",
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                0-113 kg/acre
              </div>
              <div
                style={{
                  color: "#ffffff",
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                0-9 kg/acre
              </div>
              <div
                style={{
                  color: "#ffffff",
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  width: "25%",
                  fontSize: "18px",
                }}
              >
                0-58 kg/acre
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px" }}>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Crop Health Index Table
          </p>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                border: "1px solid #e6e6e6",
                borderRadius: "4px",
                boxShadow: "0px 4px 12px 0px #b4b4b440",
                width: "25%",
              }}
            >
              <div
                style={{
                  backgroundColor: "#B0E896",
                  borderBottom: "1px solid #e6e6e6",
                  padding: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                High
              </div>
              <div style={{ padding: "12px", fontSize: "15px" }}>
                Suitable Weather condition and good/healthy value of satellite
                indices
              </div>
            </div>
            <div
              style={{
                border: "1px solid #e6e6e6",
                borderRadius: "4px",
                boxShadow: "0px 4px 12px 0px #b4b4b440",
                width: "25%",
              }}
            >
              <div
                style={{
                  backgroundColor: "#F9FFC2",
                  borderBottom: "1px solid #e6e6e6",
                  padding: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                Medium
              </div>
              <div style={{ padding: "12px", fontSize: "15px" }}>
                Optimum Weather conditions and moderate value of satellite
                indices
              </div>
            </div>
            <div
              style={{
                border: "1px solid #e6e6e6",
                borderRadius: "4px",
                boxShadow: "0px 4px 12px 0px #b4b4b440",
                width: "25%",
              }}
            >
              <div
                style={{
                  backgroundColor: "#F97979",
                  borderBottom: "1px solid #e6e6e6",
                  padding: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#ffffff",
                }}
              >
                Low
              </div>
              <div style={{ padding: "12px", fontSize: "15px" }}>
                Either weather conditions not suitable or negative indication on
                satellite indices
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "50px" }}>
          <div className="agrlogo"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img style={{ width: "10%" }} src={`${aws_s3_url}/logo.svg`} />
            <img
              style={{ width: "10%" }}
              src={`${aws_s3_url}/AgribazaarLogo.svg`}
            />
          </div>
          <p
            style={{
              color: "#585757",
              fontSize: "30px",
              fontWeight: 600,
              fontFamily: '"Poppins"',
            }}
          >
            Risk Profile Index Table
          </p>
          <div style={{ border: "1px solid #e6e6e6", borderRadius: "4px" }}>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Index
              </div>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Criteria
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Weather Risk
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Calculated with comparison to ideal weather conditions for crop
                of interest
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Flood Risk
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                ML based model to predict possibility of flood based on current
                and historic weather and satellite data
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Crop Health Risk
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Inverse function of crop health measurement
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Current Crop Suitability
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Calculated based on soil texture and nutrient availability
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Current Crop Expertise
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Evaluated based on historic farm activities and district level
                estimations as available with Aqribazaar cloud data engine
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e6e6e6",
                  fontWeight: 600,
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Farm Management
              </div>
              <div
                style={{
                  padding: "12px",
                  width: "70%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #e6e6e6",
                  fontSize: "18px",
                }}
              >
                Estimated with satellite data and package of practices served as
                input on Agribazaar app
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FarmerScoreCardv3;
